import { gql } from "gql";

export const REGISTER_DEVICE = gql(/* GraphQL */ `
  mutation RegisterDevice($installationId: String!, $token: String!) {
    registerDevice(installationId: $installationId, token: $token)
  }
`);
